import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { StockItem } from '../../core/models';

export const StockActions = createActionGroup({
  source: 'Stock',
  events: {
    'Load Stock': emptyProps(),
    'Load Stock Success': props<{ items: StockItem[] }>(),
    'Load Stock Failure': props<{ error: string }>(),
  },
});
